import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {FulfillmentStepDisplayStatusGroupType} from "../../types/fulfillment-step-display-status-group.type";
import {FulfillmentStepActionType} from "../../types/fulfillment-step-action.type";
import {TrainContainerDetails} from "../../../threePL/models/train-container-details.model";
import {ThreePlExtraData} from "../../../threePL/models/threepl-extra-data.model";
import {ExportType} from "../../../commons/types/export.type";
import {ThreePLProviderType} from "../../../threePL/types/threePL-provider.type";
import {PlanProjectEntity} from "../../../planning/models/plan-project-entity.model";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {FulfillmentFilterPayloadModel} from "../../models/fulfillment-filter-payload.model";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {PlanningDialogService} from "../../../planning/services/planning-dialogs-service.service";
import {PlanningProjectsService} from "../../../planning/services/planning-projects-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {FulfillmentAlertsService} from "../../services/fulfillment-alerts.service";
import {FulfillmentService} from "../../services/fulfillment-service.service";
import {FulfillmentStepStatusType} from "../../types/fulfillment-step-status.type";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {ThreePLServiceActionsService} from "../../../threePL/angular/services/threepl-service-actions.service";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {
  CancellationReasonsDialogsService
} from "../../../cancellation-reasons/services/cancellation-reasons-dialogs-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {FulfillmentStepService} from "../../services/fulfillment-step-service.service";
import {SortType} from "../../../commons/types/sort.type";
import {CancellationReason} from "../../../cancellation-reasons/models/cancellationReason.model";
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {Subscription} from "rxjs";
import {FulfillmentFacadeService} from "../../angular/services/fulfillment-facade.service";
import {FulfillmentModel} from "../../models/fulfillment.model";
import {
  ActionReasonsDialogsServiceService
} from "../../../action-reasons/services/action-reasons-dialogs-service.service";
import {ActionReasonEntityEnum} from "../../../action-reasons/enums/action-reason-entity.enum";
import {TrainCarDetails} from "../../../threePL/models/train-car-details.model";
import {ThreePLAlertsService} from "../../../threePL/services/threePL-alerts.service";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";

export class FulfillmentStepsViewComponent implements IController {

  from: any;
  to: any;
  queryString?: string;
  fulfillmentId?: string;
  displayStatusGroups: FulfillmentStepDisplayStatusGroupType[]
  dateRangeTemplateType?: DateRangeTemplateType;
  schedulingRequired: boolean;
  isReturnDelivery: boolean;
  obligateTimeWindow: boolean;
  accountIds: string[];
  branchIds: string[];
  serviceAreaIds: string[];
  tags: string[];
  programTypes: string[];
  packagesIds: string[];
  logisticsVehicleIds: string[];
  inRoute: any;
  serviceTypes: string[];
  approvalStatuses: string[];
  depotIds: string[];
  agentIds: string[];
  fulfillmentStepDisplayStatus: string[];
  fulfillmentMileType: string;
  filterByCreatedAt: boolean;
  resourceIds: string;
  noFromLocation: boolean;
  noToLocation: boolean;
  selectedQuickFilterId: string;
  supplyAccountIds: string[];
  dispatchType: string[];
  noPickUpArea?: boolean;
  noDropOffArea?: boolean;
  noPickUpDepot?: boolean;
  noDropOffDepot?: boolean;
  noPickUpAccount?: boolean;
  noDropOffAccount?: boolean;

  public pageName: string;
  public filtersConfig = {
    customTemplates: undefined,
    range: {
      name: undefined,
      dateStart: undefined,
      dateEnd: undefined
    },
    includeFilters: undefined,
    bringozFilters: undefined,
    filterByCreatedAt: undefined,
    queryString: undefined,
    settings: undefined,
    statuses: [],
    displayStatusGroups: []
  };
  public infiniteScroll: any;
  public loadLimit: number = 30;
  public isMobileView: boolean;
  public isScrollable: boolean;
  public isFulfillmentFullView: boolean;
  public actions: any;
  public fulfillmentStepActionType: typeof FulfillmentStepActionType = FulfillmentStepActionType;
  public displayStatusGroupType: typeof FulfillmentStepDisplayStatusGroupType = FulfillmentStepDisplayStatusGroupType;
  public excludeMode: boolean = false;
  public exportType: typeof ExportType = ExportType;
  public containers: TrainContainerDetails[];
  public threePlExtraData: ThreePlExtraData;

  public selectedStepsIds: string[] = [];
  public selectedSteps: FulfillmentStepModel[] = [];
  public selectedFulfillment: FulfillmentModel;
  public selectedDisplayStatusGroupsMap: {};
  public totals: {};
  public totalsSelectedMap: {};
  public sortTypesValues: {};
  public selectedSortValue: { name: string, type: string, value: string };
  public allowSendToPlanning: boolean;

  public fulfillmentStepsGroupStatuses: object;
  public selectedFulfillmentSubscription: Subscription;

  private stepsRef: any;

  constructor(private $mdMedia, private $steps, private splitService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $timeout,
              private $infiniteScroll, private fulfillmentService: FulfillmentService, private fulfillmentAlertsService: FulfillmentAlertsService, private $state,
              private fulfillmentDialogService: FulfillmentDialogService, private DeliveriesApiAction, private commonsDialogService: CommonsDialogService,
              private viewFilterSettingsService: ViewFilterSettingsService, private $log, private planningDialogService: PlanningDialogService, private threePLService: ThreePLServiceActionsService,
              private planningProjectsService: PlanningProjectsService, private planningConstants, private confirmDialogService: ConfirmDialogService,
              private threePLTrainService, private deliveriesRequestsService: DeliveriesRequestsService, private actionReasonsDialogsService: ActionReasonsDialogsServiceService,
              private deliveriesService: DeliveriesService, private fulfillmentStepService: FulfillmentStepService, private IAMPermissions, private deliveriesDialogService: DeliveriesDialogService,
              private FulfillmentConstants, public fulfillmentFacadeService: FulfillmentFacadeService, private threePLAlertsService: ThreePLAlertsService) {
    this.stepsRef = this.$steps();
    this.pageName = this.$state.current.name;
  }


  $onInit() {
    this.fulfillmentStepsGroupStatuses = this.FulfillmentConstants.fulfillmentStepsGroupStatuses;

    this.allowSendToPlanning = !this.IAMPermissions.hasPermission('threePL.list');

    this.filtersConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.from && this.to ? {
        name: undefined,
        dateStart: this.from,
        dateEnd: this.to
      } : this.dateRangeTimeFiltersService.thisWeek(),
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.accountIds,
        SiteFiltersType.schedulingRequired,
        SiteFiltersType.obligateTimeWindow,
        SiteFiltersType.branchIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.tags,
        SiteFiltersType.programTypes,
        SiteFiltersType.inRoute,
        SiteFiltersType.serviceTypes,
        SiteFiltersType.fulfillmentStepDisplayStatus,
        SiteFiltersType.depotIds,
        SiteFiltersType.fulfillmentMileType,
        SiteFiltersType.agentIds,
        SiteFiltersType.packagesIds,
        SiteFiltersType.logisticsVehicleIds,
        SiteFiltersType.approvalStatuses,
        SiteFiltersType.isReturnDelivery,
        SiteFiltersType.noFromLocation,
        SiteFiltersType.resourceIds,
        SiteFiltersType.noToLocation,
        SiteFiltersType.supplyAccountIds,
        SiteFiltersType.dispatchType,
        SiteFiltersType.serviceAreaPickup,
        SiteFiltersType.serviceAreaDropoff,
        SiteFiltersType.depotPickup,
        SiteFiltersType.depotDropoff,
        SiteFiltersType.accountPickup,
        SiteFiltersType.accountDropoff,
        SiteFiltersType.noPickUpArea,
        SiteFiltersType.noDropOffArea,
        SiteFiltersType.noPickUpDepot,
        SiteFiltersType.noDropOffDepot,
        SiteFiltersType.noPickUpAccount,
        SiteFiltersType.noDropOffAccount],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.resourceIds]: this.resourceIds || [],
        [SiteFiltersType.accountIds]: this.accountIds || [],
        [SiteFiltersType.schedulingRequired]: this.schedulingRequired,
        [SiteFiltersType.noFromLocation]: this.noFromLocation,
        [SiteFiltersType.noToLocation]: this.noToLocation,
        [SiteFiltersType.obligateTimeWindow]: this.obligateTimeWindow,
        [SiteFiltersType.isReturnDelivery]: this.isReturnDelivery,
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.tags]: this.tags || [],
        [SiteFiltersType.depotIds]: this.depotIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.programTypes]: this.programTypes || [],
        [SiteFiltersType.packagesIds]: this.packagesIds || [],
        [SiteFiltersType.approvalStatuses]: this.approvalStatuses || [],
        [SiteFiltersType.logisticsVehicleIds]: this.logisticsVehicleIds || [],
        [SiteFiltersType.inRoute]: this.inRoute,
        [SiteFiltersType.serviceTypes]: this.serviceTypes || [],
        [SiteFiltersType.fulfillmentStepDisplayStatus]: this.fulfillmentStepDisplayStatus || [],
        [SiteFiltersType.fulfillmentMileType]: this.fulfillmentMileType,
        [SiteFiltersType.supplyAccountIds]: this.supplyAccountIds || [],
        [SiteFiltersType.displayStatusGroups]: this.displayStatusGroups || [],
        [SiteFiltersType.dispatchType]: this.dispatchType,
        [SiteFiltersType.noPickUpArea]: this.noPickUpArea,
        [SiteFiltersType.noDropOffArea]: this.noDropOffArea,
        [SiteFiltersType.noPickUpDepot]: this.noPickUpDepot,
        [SiteFiltersType.noDropOffDepot]: this.noDropOffDepot,
        [SiteFiltersType.noPickUpAccount]: this.noPickUpAccount,
        [SiteFiltersType.noDropOffAccount]: this.noDropOffAccount
      },
      filterByCreatedAt: this.filterByCreatedAt,
      queryString: this.queryString,
      settings: this.splitService.getSiteFulfillmentSettings(),
      statuses: [],
      displayStatusGroups: []
    }

    if (this.displayStatusGroups?.length) {
      this._setDisplayStatusGroups(this.displayStatusGroups);
    }

    this.sortTypesValues = {
      sortCreatedAt: {asc: 'createdAt,asc', desc: 'createdAt,desc'},
    };

    this.stepsRef.$query({extend: true});
    const payload = this._getFulfillmentFilterPayloadModel();
    this.infiniteScroll = this.$infiniteScroll(this.stepsRef, this.loadLimit, {data: payload, getFullData: true});

    // Set selected fulfillment
    if (this.fulfillmentId) {
      this.onSetSelectedFulfillment(this.fulfillmentId);
    }

    this.fulfillmentFacadeService.subscribeToChannels();

    this._getTotals();
  }

  $doCheck() {
    this.isMobileView = this.$mdMedia('xs');
  }

  $onDestroy() {
    this.selectedFulfillmentSubscription?.unsubscribe();
    this.fulfillmentFacadeService.removeAll();
  }

  onStatusSelect(displayStatusGroup: FulfillmentStepDisplayStatusGroupType) {
    const displayStatusGroupIndex = this.filtersConfig.displayStatusGroups.findIndex(sg => {
      return displayStatusGroup === sg;
    })
    let displayStatusGroupsCopy = angular.copy(this.filtersConfig.displayStatusGroups);

    if (!displayStatusGroup) {
      displayStatusGroupsCopy = [];
    } else if (displayStatusGroupIndex > -1) {
      displayStatusGroupsCopy.splice(displayStatusGroupIndex, 1)
    } else {
      displayStatusGroupsCopy.push(displayStatusGroup);
    }

    this._setDisplayStatusGroups(displayStatusGroupsCopy);
    this._getTotals();
    this._reloadQuery();
    this._setStateParams();
  }

  onQueryChange(queryString) {
    this.filtersConfig.queryString = queryString;
    this._getTotals();
    this._reloadQuery();
    this._setStateParams();
  }

  onRangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filtersConfig.range.name)) {
      this.filtersConfig.range = range;
      this._getTotals();
      this._reloadQuery();
      this._setStateParams();
    }
  }

  onDateSortByChange() {
    this.selectedSteps = [];
    this.selectedStepsIds = [];
    this.excludeMode = false;

    this._getTotals();
    this._reloadQuery();
    this._setStateParams();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    this.allowSendToPlanning = !this.allowSendToPlanning && filters.dispatchType === FulfillmentSubTypeType.Dispatch

    this.selectedSteps = [];
    this.selectedStepsIds = [];
    this.excludeMode = false;
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    if (!!filters.dateRangeTemplateType) {
      this.filtersConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._getTotals();
    this._reloadQuery();
    this._setStateParams();
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this._reloadQuery();
  }

  onOpenActionsMenu($mdMenu, ev) {
    this.actions = this.fulfillmentService.fulfillmentsActions(this.selectedSteps);
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  onViewSettingsChange(settings) {
    this.filtersConfig.settings = settings;
    this.splitService.setSiteFulfillmentSettings(settings);

    this.fulfillmentAlertsService.viewSettingsChangesSuccess();
  }

  onSetSelectedFulfillment(fulfillmentId: string) {
    if (fulfillmentId) {
      // this._getFulfillment(fulfillmentId)
      //   .then(fulfillment => {
      //     this.selectedFulfillment = angular.copy(fulfillment);
      //   })
      this.fulfillmentFacadeService.getOne(fulfillmentId, true);

      this.selectedFulfillmentSubscription = this.fulfillmentFacadeService.selectOne(fulfillmentId)
        .subscribe((fulfillment: FulfillmentModel) => {
          if (!!fulfillment) {
            this.selectedFulfillment = angular.copy(fulfillment);
            this._addStepNumberToFulfillment(this.selectedFulfillment);
            this.$timeout(0).then(() => {
            });
          }
        })
    } else {
    }
  }

  onSelectedFulfillmentChange(fulfillment: FulfillmentModel) {
    // this.selectedFulfillment = fulfillment;
  }

  onSelectStep(step: FulfillmentStepModel) {
    const stepIndex = this.selectedSteps?.findIndex(s => {
      return s.id === step.id;
    })
    const selectedStepsCopy = angular.copy(this.selectedSteps);
    if (stepIndex > -1) {
      selectedStepsCopy.splice(stepIndex, 1)
    } else {
      selectedStepsCopy.push(step);
    }

    this.selectedSteps = selectedStepsCopy;
    this.selectedStepsIds = selectedStepsCopy.map(step => {
      return step.id
    });
  }

  onToggleSelectAllSteps(excludeMode: boolean) {
    this.excludeMode = excludeMode;
    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onToggleSelectStep(step: FulfillmentStepModel) {
    const selectedStepsCopy = angular.copy(this.selectedSteps);
    const stepIndex = _.findIndex(selectedStepsCopy, s => {
      return s.id === step.id;
    })

    if (stepIndex > -1) {
      selectedStepsCopy.splice(stepIndex, 1);
    } else {
      selectedStepsCopy.push(step);
    }

    this.selectedSteps = selectedStepsCopy;
    this.selectedStepsIds = selectedStepsCopy.map(step => {
      return step.id
    });
  }

  onToggleFulfillmentFullView() {
    this.isFulfillmentFullView = !this.isFulfillmentFullView
  }

  onCloseFulfillmentSection() {
    if (!this.isFulfillmentFullView && this.selectedFulfillment) {
      this.fulfillmentFacadeService.removeAll();
      this.selectedFulfillmentSubscription?.unsubscribe();
      this.isFulfillmentFullView = false;
      this.selectedFulfillment = undefined;
      this._setStateParams();
    } else {
      this.isFulfillmentFullView = false;
    }
  }

  onCreateVoucher(step?) {

    let steps;
    if (step) {
      steps = [step];
    } else {
      steps = angular.copy(this.selectedSteps);
    }

    _.forEach(steps, (s) => {
      s.items = angular.copy(s.itemsExt);
    })

    this.containers = this.threePLTrainService.getContainersBySteps(steps);
    this.threePlExtraData = {
      type: ThreePLProviderType.TrainIL,
      name: undefined,
      carsDetails: [],
      approvalStatus: undefined,
      pickupDepotId: _.get(steps, '[0].pickup.depotReference.id'),
      destinationDepotId: _.get(steps, '[0].destination.depotReference.id'),
      pickupTrainStation: undefined,
      destinationTrainStation: undefined
    }
  }

  //// Bulk actions
  onExport(event, exportType) {
    let count = 0;
    const selectedStatuses: string[] = this._getSelectedStatuses();

    for (const status of selectedStatuses) {
      const matchedKey = Object.keys(this.totals).find(
        key => key.toLowerCase() === status.toLowerCase()
      );

      if (matchedKey && this.totals[matchedKey]) {
        count += this.totals[matchedKey];
      }
    }

    const text = 'Are you sure you want to export steps?';
    let extraText;

    if (exportType === ExportType.Excel) {
      if (count > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Steps to File', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this._onExport(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    } else if (ExportType.CSV) {
      if (count > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Steps to File', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this._onExport(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    }
  }

  onSendToPlanning(event) {
    this.planningDialogService.createOrSelectProject(event, false, undefined, undefined, true)
      .then((payload: { project: PlanProjectEntity, projectId: string }) => {
        if (payload.project) {
          this._createProjectWithSteps(payload.project);
        }
        if (payload.projectId) {
          this._sendStepsToExistingProject(payload.projectId);
        }

        this.selectedSteps = [];
        this.selectedStepsIds = [];

      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onBulkSendToDispatch() {
    this.fulfillmentDialogService.bulkDispatch()
      .then(data => {
        this.bulkDispatch(data);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onAssignAgentToServices(event) {
    this.DeliveriesApiAction.assignAgent(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onMultiAssignToAgent(event) {
    this.deliveriesDialogService.multipleAssignToAgent(event, this.selectedSteps);

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onAutoAssignServices(event) {
    this.DeliveriesApiAction.autoAssignAgent(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onAddServicesToRoute(event) {
    this.DeliveriesApiAction.assignRoute(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onResetServices(event) {
    this.DeliveriesApiAction.reset(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onAddServicesToResource(event) {
    this.DeliveriesApiAction.assignResourceAllocation(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  onCompleteStepsManually(event) {
    this.fulfillmentDialogService.manualHandle(event)
      .then((note) => {
        this._manualHandleFulfillmentStep(this.selectedStepsIds, note);

        this.selectedSteps = [];
        this.selectedStepsIds = [];
      })
  }

  onCancelSteps(event) {
    this.confirmDialogService.confirm('Confirm Legs Cancellation',
      'Upon canceling a Leg, the associated packages will not form a gap, the Order will remain unchanged, however,' +
      ' this action might impact related Legs or Lines. Are you sure you want to proceed?', event)
      .then(() => {
        this._onCancelSteps(this.selectedStepsIds);

        this.selectedSteps = [];
        this.selectedStepsIds = [];
      })
  }

  //////
  onDispatchStep(step: FulfillmentStepModel, event?) {
    this._getFulfillment(step.fulfillmentId)
      .then(fulfillment => {
        this.fulfillmentDialogService.dispatchStep(fulfillment, [step.id], event);
      })
  }

  onAutoAssignService(serviceId: string, event) {
    this.DeliveriesApiAction.autoAssignAgent(event, [serviceId]);
  }

  onAssignAgentToService(serviceId: string, event) {
    this.DeliveriesApiAction.assignAgent(event, [serviceId]);
  }

  onAssignRouteToService(serviceId: string, event) {
    this.DeliveriesApiAction.assignRoute(event, [serviceId]);
  }

  onCancelService(serviceId: string, serviceType: string, event, serviceSubType: string) {
    if (serviceSubType === 'ThirdParty') {
      this.actionReasonsDialogsService.createThreeplServiceCancelReason([serviceId], event, 'Cancel Service', true, [serviceType])
        .then((payload) => {
          this._cancelService(serviceId, payload, serviceSubType)
        })
    } else {
      this.actionReasonsDialogsService.createCancelTaskReason([serviceId], event, true, undefined, [serviceType])
        .then((payload) => {
          this._cancelService(serviceId, payload, serviceSubType, serviceType, event)
        })
    }
  }

  onCancelServices(event) {
    this.actionReasonsDialogsService.createThreeplServiceCancelReason(undefined, event, undefined, undefined ,[ActionReasonEntityEnum.Delivery,ActionReasonEntityEnum.Operation])
      .then((payload) => {
        this._cancelServices(this.selectedStepsIds, payload.cancelReason);

        this.selectedSteps = [];
        this.selectedStepsIds = [];
      })
  }

  onDispatchStepExternal(step: FulfillmentStepModel, event?) {
    this.fulfillmentDialogService.dispatchStepExternal(step.fulfillmentId, step, event)
      .then((selectedQuote) => {
        this.fulfillmentService.dispatchStep(step.fulfillmentId, step.id, selectedQuote)
      })
  }

  onResetService(serviceId: string, serviceType: string, event) {
    this.DeliveriesApiAction.reset(event, [serviceId], serviceType);
  }

  onAssignResourceAllocation(serviceId: string, event) {
    this.DeliveriesApiAction.assignResourceAllocation(event, [serviceId]);
  }

  onCompleteStepManually(stepId: string, event) {
    this.fulfillmentDialogService.manualHandle(event, stepId)
      .then((note) => {
        this._manualHandleFulfillmentStep([stepId], note);
      })
  }

  onAddNoteToService(serviceId: string, event, serviceSubType: string) {
    this.commonsDialogService.note(event, [serviceId])
      .then((note) => {
        this._addNoteToService(serviceId, note, serviceSubType);
      })
  }

  onCreateRoute(serviceId: string, event) {
    this.DeliveriesApiAction.createRoute(event, [serviceId]);
  }

  onCancelStep(step: FulfillmentStepModel) {
    if (step.status === FulfillmentStepStatusType.Pending) {
      this.confirmDialogService.confirm('Confirm Leg Cancellation',
        'Upon canceling a Leg, the associated packages will not form a gap, the Order will remain unchanged, however, this action might impact related Legs or Lines. Are you sure you want to proceed?', event)
        .then(() => {
          this._onCancelStep(step.fulfillmentId, step.id);
        })
    } else {
      const activeAttempt = _.find(step.attempts, (a) => {
        return a.referenceId === step.referenceId;
      });
      this.fulfillmentDialogService.createCancelTaskReason([activeAttempt.id], event, 'Confirm Leg Cancellation', activeAttempt.type)
        .then((payload) => {
          this._onCancelStep(step.fulfillmentId, step.id, payload.cancelReason);
        })
        .catch((error) => {
          this.$log.debug('Dialog Closed');
        })
    }
  }

  onFilterByType(type, value) {
    if (_.isArray(this.filtersConfig.bringozFilters[type])) {
      if (_.isArray(value)) {
        this.filtersConfig.bringozFilters[type] = _.uniq(this.filtersConfig.bringozFilters[type].concat(value));
      } else {
        if (!_.includes(this.filtersConfig.bringozFilters[type], value)) {
          this.filtersConfig.bringozFilters[type].push(value);
        }
      }
    } else {
      this.filtersConfig.bringozFilters[type] = value;
    }
    this._setStateParams();
    this._reloadQuery();
  }

  onSaveVoucher(threePlExtraData: ThreePlExtraData, supplierAccountId: string, date) {
    const stepIds = this.selectedSteps.length ? _.map(this.selectedSteps, 'id') : [];

    if (!stepIds.length) {
      threePlExtraData.carsDetails.forEach((car: TrainCarDetails) => {
        car.trainContainerDetails.forEach((c) => {
          if (!!c.stepId) {
            stepIds.push(c.stepId)
          }
        })
      })
    }

    this.threePLTrainService.createVoucher(threePlExtraData, supplierAccountId, stepIds, date, date)
      .then((steps: any[]) => {
        this.threePlExtraData = undefined;
        this.containers = undefined;

        this.threePLAlertsService.trainVoucherCreateSuccess(true)
          .then((res) => {
            if (res) {
              const attempt: any = _.last(steps[0].attempts);
              const threeplServiceId = attempt?.referenceId;
              this.$state.go('threePL.train.vouchers', {serviceId: threeplServiceId})
            }
          });
        // this._initFulfillments(true);
      })
  }

  unSelectSteps() {
    this.excludeMode = false;
    this.selectedSteps = [];
    this.selectedStepsIds = [];
  }

  private _cancelServices(stepIds: string[], cancellationReason: CancellationReason) {
    const payload = {
      reason: cancellationReason.reason,
      description: cancellationReason.description,
      comment: cancellationReason.comment,
      fulfillmentFilter: {
        stepFilter: this._getStepFilterPayload(),
        searchTerm: this.filtersConfig.queryString
      }
    }

    if (this.excludeMode) {
      payload.fulfillmentFilter.stepFilter.excludeIds = stepIds;
      payload.fulfillmentFilter.stepFilter.includeIds = [];
    } else {
      payload.fulfillmentFilter.stepFilter.ids = stepIds;
    }

    this.fulfillmentStepService.cancelAttempt(payload);
  }

  private _onCancelSteps(stepIds: string[]) {
    this.fulfillmentStepService.cancelSteps(stepIds);
  }

  private _manualHandleFulfillmentStep(stepIds: string[], note: string) {

    const payload = {
      note: note,
      fulfillmentFilter: {
        stepFilter: this._getStepFilterPayload(),
        searchTerm: this.filtersConfig.queryString
      }
    }

    if (this.excludeMode) {
      payload.fulfillmentFilter.stepFilter.excludeIds = stepIds;
      payload.fulfillmentFilter.stepFilter.includeIds = [];
    } else {
      payload.fulfillmentFilter.stepFilter.ids = stepIds;
    }

    this.fulfillmentStepService.manualHandleAttempt(payload);
  }

  private _cancelService(serviceId, payload, serviceSubType, serviceType?, $event?) {
    if (serviceSubType === 'ThirdParty') {
      this.threePLService.cancelService([serviceId], payload.cancelReason);
    } else {
      const totalIds = _.concat([serviceId], payload.relatedServicesIds);
      this.deliveriesService.cancelService($event, totalIds, serviceType, payload.cancelReason)
    }
  }

  private _getFulfillment(fulfillmentId: string) {
    return this.fulfillmentService.getFulfillment(fulfillmentId, true);
  }

  private _addNoteToService(serviceId, note, serviceSubType) {
    if (serviceSubType === 'ThirdParty') {
      this.threePLService.addNote([serviceId], note);
    } else {
      this.deliveriesRequestsService.addNote([serviceId], note);
    }
  }

  private _onCancelStep(fulfillmentId, stepId, cancelReason?) {
    this.fulfillmentService.cancelStep(fulfillmentId, stepId, cancelReason);
  }

  private _getTotals() {
    const filters = angular.copy(this._getFulfillmentFilterPayloadModel());
    filters.stepFilter.displayStatusGroups = undefined;
    this.fulfillmentService.getFulfillmentsTotals(filters)
      .then(totals => {
        this.totals = totals;
      })
  }

  private _setDisplayStatusGroups(displayStatusGroups) {
    this.filtersConfig.displayStatusGroups = displayStatusGroups;

    const selectedDisplayStatusGroupsMap = {};
    displayStatusGroups.forEach(s => {
      selectedDisplayStatusGroupsMap[_.camelCase(s)] = true;
    })
    this.selectedDisplayStatusGroupsMap = selectedDisplayStatusGroupsMap;
  }

  private getSelectedStepsServicesIds(steps) {
    return _.chain(steps)
      .filter(s => {
        return s.attempts
      })
      .map(s => {
        return _.find(s.attempts, attempt => {
          return attempt.id === s.referenceId;
        }).id
      })
      .value()
  }

  private _getFulfillmentFilterPayloadModel(): FulfillmentFilterPayloadModel {

    let fromLocationIds = [];
    let toLocationIds = [];
    // Service Areas Location
    if (!this.filtersConfig.bringozFilters.noPickUpArea) {
      fromLocationIds = fromLocationIds.concat(this.filtersConfig.bringozFilters.serviceAreaIds)
    }
    if (!this.filtersConfig.bringozFilters.noDropOffArea) {
      toLocationIds = toLocationIds.concat(this.filtersConfig.bringozFilters.serviceAreaIds)
    }
    // Depots Location
    if (!this.filtersConfig.bringozFilters.noPickUpDepot) {
      fromLocationIds = fromLocationIds.concat(this.filtersConfig.bringozFilters.depotIds)
    }
    if (!this.filtersConfig.bringozFilters.noDropOffDepot) {
      toLocationIds = toLocationIds.concat(this.filtersConfig.bringozFilters.depotIds)
    }
    // Accounts Location
    if (!this.filtersConfig.bringozFilters.noPickUpAccount) {
      fromLocationIds = fromLocationIds.concat(this.filtersConfig.bringozFilters.accountIds)
    }
    if (!this.filtersConfig.bringozFilters.noDropOffAccount) {
      toLocationIds = toLocationIds.concat(this.filtersConfig.bringozFilters.accountIds)
    }
    return {
      stepFilter: {
        from: this.filtersConfig.range.dateStart,
        to: this.filtersConfig.range.dateEnd,
        displayStatusGroups: this.filtersConfig.displayStatusGroups.filter(s => s !== 'Total'),
        accountIds: _.filter(this.filtersConfig.bringozFilters.accountIds, (id) => {
          return !_.includes(fromLocationIds.concat(toLocationIds), id);
        }),
        vehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
        schedulingRequired: this.filtersConfig.bringozFilters.schedulingRequired,
        noFromLocation: this.filtersConfig.bringozFilters.noFromLocation,
        noToLocation: this.filtersConfig.bringozFilters.noToLocation,
        obligateTimeWindow: this.filtersConfig.bringozFilters.obligateTimeWindow,
        isReturn: this.filtersConfig.bringozFilters.isReturnDelivery,
        branchIds: this.filtersConfig.bringozFilters.branchIds,
        serviceAreaIds: _.filter(this.filtersConfig.bringozFilters.serviceAreaIds, (id) => {
          return !_.includes(fromLocationIds.concat(toLocationIds), id);
        }),
        tags: this.filtersConfig.bringozFilters.tags,
        routed: this.filtersConfig.bringozFilters.inRoute,
        programTypes: this.filtersConfig.bringozFilters.programTypes,
        approvalStatuses: this.filtersConfig.bringozFilters.approvalStatuses,
        types: this.filtersConfig.bringozFilters.serviceTypes,
        displayStatuses: this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus,
        depotIds: _.filter(this.filtersConfig.bringozFilters.depotIds, (id) => {
          return !_.includes(fromLocationIds.concat(toLocationIds), id);
        }),
        filterByCreatedAt: this.filtersConfig.filterByCreatedAt,
        agentIds: this.filtersConfig.bringozFilters.agentIds,
        firstMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'firstMile' ? true : undefined,
        middleMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'middleMile' ? true : undefined,
        lastMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'lastMile' ? true : undefined,
        resourceIds: this.filtersConfig.bringozFilters.resourceIds,
        packageTypes: this.filtersConfig.bringozFilters.packagesIds,
        excludeAttemptSubtypes: this.filtersConfig.bringozFilters.dispatchType ? (this.filtersConfig.bringozFilters.dispatchType === FulfillmentSubTypeType.ThirdParty ? [FulfillmentSubTypeType.Dispatch] : [FulfillmentSubTypeType.ThirdParty]) : undefined,
        supplyAccountIds: this.filtersConfig.bringozFilters.supplyAccountIds,
        notMatchStatuses: [FulfillmentStepStatusType.Splitted],
        fromLocationIds: fromLocationIds,
        toLocationIds: toLocationIds
      },
      searchTerm: this.filtersConfig.queryString
    }
  }

  private _reloadQuery() {
    this.stepsRef.$query({extend: true, sort: _.get(this.selectedSortValue, 'value')})
      .then(() => {
        const payload = this._getFulfillmentFilterPayloadModel();
        this.infiniteScroll.reload({data: payload, getFullData: true});
      }, (resp) => {
        // this.$log.debug('Fail to $query', resp);
      });
  }

  private _setStateParams() {
    this.$state.go('.', {
      // dateRangeTemplateType: this.filtersConfig.bringozFilters.dateRangeTemplateType,
      fulfillmentId: _.get(this.selectedFulfillment, 'id'),
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      queryString: this.filtersConfig.queryString,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      logisticsVehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
      isReturnDelivery: this.filtersConfig.bringozFilters.isReturnDelivery,
      schedulingRequired: this.filtersConfig.bringozFilters.schedulingRequired,
      noFromLocation: this.filtersConfig.bringozFilters.noFromLocation,
      noToLocation: this.filtersConfig.bringozFilters.noToLocation,
      approvalStatuses: this.filtersConfig.bringozFilters.approvalStatuses,
      obligateTimeWindow: this.filtersConfig.bringozFilters.obligateTimeWindow,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      tags: this.filtersConfig.bringozFilters.tags,
      depotIds: this.filtersConfig.bringozFilters.depotIds,
      inRoute: this.filtersConfig.bringozFilters.inRoute,
      programTypes: this.filtersConfig.bringozFilters.programTypes,
      packagesIds: this.filtersConfig.bringozFilters.packagesIds,
      serviceTypes: this.filtersConfig.bringozFilters.serviceTypes,
      fulfillmentStepDisplayStatus: this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus,
      fulfillmentMileType: this.filtersConfig.bringozFilters.fulfillmentMileType,
      resourceIds: this.filtersConfig.bringozFilters.resourceIds,
      filterByCreatedAt: this.filtersConfig.filterByCreatedAt,
      supplyAccountIds: this.filtersConfig.bringozFilters.supplyAccountIds,
      displayStatusGroups: this.filtersConfig.bringozFilters.displayStatusGroups,
      dispatchType: this.filtersConfig.bringozFilters.dispatchType,
      selectedQuickFilterId: this.selectedQuickFilterId,
      noPickUpArea: this.filtersConfig.bringozFilters.noPickUpArea,
      noDropOffArea: this.filtersConfig.bringozFilters.noDropOffArea,
      noPickUpDepot: this.filtersConfig.bringozFilters.noPickUpDepot,
      noDropOffDepot: this.filtersConfig.bringozFilters.noDropOffDepot,
      noPickUpAccount: this.filtersConfig.bringozFilters.noPickUpAccount,
      noDropOffAccount: this.filtersConfig.bringozFilters.noDropOffAccount
    }, {notify: false, reload: false});
  }

  private bulkDispatch(milesData) {
    const FulfillmentBulkDispatchRequest = {
      filter: {
        stepFilter: this._getStepFilterPayload(),
        fulfillmentFilter: {
          packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
        },
        searchTerm: this.filtersConfig.queryString
      },
      timeWindowsPerLeg: this._getTimeWindowsPerLegPayload(milesData),
      sendSms: true
    };

    if (_.isEmpty(FulfillmentBulkDispatchRequest.filter.fulfillmentFilter)) {

      _.unset(FulfillmentBulkDispatchRequest.filter, 'fulfillmentFilter');
    }

    if (this.excludeMode) {
      FulfillmentBulkDispatchRequest.filter.stepFilter.excludeIds = this.selectedStepsIds;
      FulfillmentBulkDispatchRequest.filter.stepFilter.includeIds = [];
    } else {
      FulfillmentBulkDispatchRequest.filter.stepFilter.ids = this.selectedStepsIds;
    }

    this.fulfillmentService.bulkDispatch(FulfillmentBulkDispatchRequest);

  }

  private _createProjectWithSteps(project) {
    const payloadRequest = {
      filter: {
        stepFilter: this._getStepFilterPayload(),
        fulfillmentFilter: {
          packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
        },
        searchTerm: this.filtersConfig.queryString
      },
      project: project
    };

    if (this.excludeMode) {
      payloadRequest.filter.stepFilter.excludeIds = this.selectedStepsIds;
      payloadRequest.filter.stepFilter.includeIds = [];
    } else {
      payloadRequest.filter.stepFilter.ids = this.selectedStepsIds;
    }

    this.planningProjectsService.createProjectWithFulfillments(payloadRequest)
      .then((createdProject: any) => {
        this.$state.go(this.planningConstants.states.project, {projectId: createdProject.id});
      });
  }

  private _sendStepsToExistingProject(projectId: string) {
    const payloadRequest = {
      stepFilter: this._getStepFilterPayload(),
      fulfillmentFilter: {
        packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
      },
      searchTerm: this.filtersConfig.queryString
    }


    if (this.excludeMode) {
      payloadRequest.stepFilter.excludeIds = this.selectedStepsIds;
      payloadRequest.stepFilter.includeIds = [];
    } else {
      payloadRequest.stepFilter.ids = this.selectedStepsIds;
    }

    this.planningProjectsService.addFulfillments(payloadRequest, projectId).then(() => {
      this.$state.go(this.planningConstants.states.project, {projectId: projectId});
    })
  }

  private _onExport(exportType) {
    const payload = {
      stepFilter: this._getStepFilterPayload(),
      searchTerm: this.filtersConfig.queryString
    }
    this.fulfillmentService.exportFulfillmentSteps(payload, exportType);
  }

  private _getStepFilterPayload() {
    return {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      schedulingRequired: this.filtersConfig.bringozFilters.schedulingRequired,
      noFromLocation: this.filtersConfig.bringozFilters.noFromLocation,
      noToLocation: this.filtersConfig.bringozFilters.noToLocation,
      vehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
      obligateTimeWindow: this.filtersConfig.bringozFilters.obligateTimeWindow,
      isReturn: this.filtersConfig.bringozFilters.isReturnDelivery,
      approvalStatuses: this.filtersConfig.bringozFilters.approvalStatuses,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      tags: this.filtersConfig.bringozFilters.tags,
      routed: this.filtersConfig.bringozFilters.inRoute,
      programTypes: this.filtersConfig.bringozFilters.programTypes,
      logisticsVehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
      types: this.filtersConfig.bringozFilters.serviceTypes,
      displayStatuses: this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus,
      depotIds: this.filtersConfig.bringozFilters.depotIds,
      filterByCreatedAt: this.filtersConfig.filterByCreatedAt,
      firstMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'firstMile' ? true : undefined,
      middleMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'middleMile' ? true : undefined,
      lastMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'lastMile' ? true : undefined,
      displayStatusGroups: this.filtersConfig.displayStatusGroups.filter(s => s !== 'Total'),
      supplyAccountIds: this.filtersConfig.bringozFilters.supplyAccountIds,
      packageTypes: this.filtersConfig.bringozFilters.packagesIds,
      excludeAttemptSubtypes: this.filtersConfig.bringozFilters.dispatchType ? (this.filtersConfig.bringozFilters.dispatchType === FulfillmentSubTypeType.ThirdParty ? [FulfillmentSubTypeType.Dispatch] : [FulfillmentSubTypeType.ThirdParty]) : undefined,
      excludeIds: [],
      includeIds: [],
      ids: []
    }
  }

  private _getTimeWindowsPerLegPayload(milesData) {
    return {
      firstMile: {
        active: milesData.firstMile.active,
        pickupNotBefore: milesData.firstMile.isPerServiceOrTask === 'perService' ? milesData.firstMile.deliveryStartTime : milesData.firstMile.originStartTime,
        pickupNotAfter: milesData.firstMile.isPerServiceOrTask === 'perService' ? milesData.firstMile.deliveryEndTime : milesData.firstMile.originEndTime,
        destinationNotBefore: milesData.firstMile.deliveryStartTime,
        destinationNotAfter: milesData.firstMile.deliveryEndTime
      },
      middleMile: {
        active: milesData.middleMile.active,
        pickupNotBefore: milesData.middleMile.isPerServiceOrTask === 'perService' ? milesData.middleMile.deliveryStartTime : milesData.middleMile.originStartTime,
        pickupNotAfter: milesData.middleMile.isPerServiceOrTask === 'perService' ? milesData.middleMile.deliveryEndTime : milesData.middleMile.originEndTime,
        destinationNotBefore: milesData.middleMile.deliveryStartTime,
        destinationNotAfter: milesData.middleMile.deliveryEndTime
      },
      lastMile: {
        active: milesData.lastMile.active,
        pickupNotBefore: milesData.lastMile.isPerServiceOrTask === 'perService' ? milesData.lastMile.deliveryStartTime : milesData.lastMile.originStartTime,
        pickupNotAfter: milesData.lastMile.isPerServiceOrTask === 'perService' ? milesData.lastMile.deliveryEndTime : milesData.lastMile.originEndTime,
        destinationNotBefore: milesData.lastMile.deliveryStartTime,
        destinationNotAfter: milesData.lastMile.deliveryEndTime
      },
      manualBranchIds: milesData.manualBranchIds
    }
  }

  private _addStepNumberToFulfillment(fulfillment) {
    _.forEach(fulfillment.fulfillmentSteps, (s, index) => {
      s.stepNumber = index + 1
    })
  }

  private _getSelectedStatuses(): string[] {
    if (!this.selectedDisplayStatusGroupsMap) {
      return [FulfillmentStepDisplayStatusGroupType.total.toLowerCase()]
    }
    return Object.values(FulfillmentStepDisplayStatusGroupType).filter(
      (status) => this.selectedDisplayStatusGroupsMap[lowercaseFirstLetter(status)]);

    function lowercaseFirstLetter(str: string): string {
      if (!str) return '';
      return str.charAt(0).toLowerCase() + str.slice(1);
    }
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsView', {
    bindings: {
      from: '<',
      to: '<',
      queryString: '<?',
      fulfillmentId: '<?',
      displayStatusGroups: '<?',
      dateRangeTemplateType: '<?',
      accountIds: '<?',
      branchIds: '<?',
      schedulingRequired: '<?',
      noFromLocation: '<?',
      noToLocation: '<?',
      obligateTimeWindow: '<?',
      isReturnDelivery: '<?',
      serviceAreaIds: '<?',
      tags: '<?',
      depotIds: '<?',
      agentIds: '<?',
      inRoute: '<?',
      programTypes: '<?',
      packagesIds: '<?',
      serviceTypes: '<?',
      approvalStatuses: '<',
      logisticsVehicleIds: '<',
      resourceIds: '<',
      supplyAccountIds: '<?',
      fulfillmentStepDisplayStatus: '<?',
      fulfillmentMileType: '<?',
      filterByCreatedAt: '<?',
      dispatchType: '<?',
      selectedQuickFilterId: '<?',
      noPickUpArea: '<?',
      noDropOffArea: '<?',
      noPickUpDepot: '<?',
      noDropOffDepot: '<?',
      noPickUpAccount: '<?',
      noDropOffAccount: '<?'
    },
    template: require('./fulfillment-steps-view.html').default,
    controller: FulfillmentStepsViewComponent
  });
